export default "__VITE_ASSET__Dxdt0umK__"